import React from "react";
import { Button } from "rebass";
import styled from "styled-components";
import FaFacebookSquare from "react-icons/lib/fa/facebook-square";
import messengerLogo from "../../img/facebook-messenger-white.svg";

type Props = {
  children: React.Node,
  type?: string
};

const FacebookButton = (props: Props) => (
  <StyledButton {...props}>
    {props.type === "facebook" ? (
      <FaFacebookSquare />
    ) : (
      <StyledMessengerLogo src={messengerLogo} />
    )}{" "}
    <Label>{props.children}</Label>
  </StyledButton>
);

FacebookButton.defaultProps = {
  type: "facebook"
};

export default FacebookButton;

const StyledButton = styled(Button)`
  background: ${p =>
    (p.type === "facebook"
      ? p.theme.colors.facebookBlue
      : p.theme.colors.messengerBlue)};
  color: #fff;
  cursor: pointer;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  line-height: ${p => (p.type === "facebook" ? "18px" : "20px")};
  letter-spacing: -0.15px;
  padding: 15px 20px;
  text-shadow: ${p => (p.type === "facebook" ? "0 1px 1px #22377e" : "none")};

  &:focus {
    box-shadow: 2px 2px 0 #eee;
    color: #fff;
  }

  &:active {
    background: ${p =>
      (p.type === "facebook"
        ? p.theme.colors.facebookBlue
        : p.theme.colors.messengerBlue)};
    color: #fff;
  }

  &:hover,
  &:visited {
    color: #fff;
  }
`;

const Label = styled.span`
  vertical-align: middle;
`;

const StyledMessengerLogo = styled.img`
  position: relative;
  top: 3.5px;
  width: 16px;
`;



// WEBPACK FOOTER //
// ./src/components/ui/FacebookButton.jsx